import React , { Component } from 'react';
import Footer from "../../components/Footer";
import Nav from '../../components/Nav/index';
import './index.less';
import anime from 'animejs';
import { message } from "antd";
import Loader from '../../components/loader';
import { Player, BigPlayButton,LoadingSpinner,ControlBar, VolumeMenuButton } from 'video-react';
import $ from 'jquery';
import Utils from '../../utils/utils';
// import "../../../node_modules/video-react/dist/video-react.css";
import close from '../../assets/img/shut_down.png';
import facebook from '../../assets/img/f.png';
import weibo from '../../assets/img/weibo.png';
import Axios from "../../axios";

export default class Contact extends Component{
    state = {
        visible: false,
        officeAddress:'',
        isEn:false,
        isEnName:true,
        isLoading:true,
        timer:null
    }
    componentWillMount() {
        this.contactRequest();//获取联系
    }
    componentDidMount() {
        this.state.timer=setInterval(()=>{
            if(this.state.isEnName){
                $(".animation-ch").fadeOut("slow",()=> {
                    console.log('111')
                    this.setState({
                        isEnName:false
                    },()=>{
                        $(".animation-en").fadeIn("slow");
                    })
                });

            }else{
                $(".animation-en").fadeOut("slow",()=> {
                    console.log('111')
                    this.setState({
                        isEnName:true
                    },()=>{
                        $(".animation-ch").fadeIn("slow");
                    })
                });
            }
        }, 5000)
    }
    componentWillUnmount() {
        if(this.state.timer!= null) {
            clearInterval(this.state.timer);
        }
    }
    //弹窗
    showModal = (e,name) => {
        if(this.state.timer!= null) {
            clearInterval(this.state.timer);
        }
        const { officeAddress } = this.state;
        officeAddress.map((item,index)=>{
            if(item.name === name){
                this.setState({
                    modalInfo:item,
                    isEn:false
                })
            }else if(item.nameEn === name){
                this.setState({
                    modalInfo:item,
                    isEn:true
                })
            }
        })
        this.setState({
            visible: true
        });
        anime.timeline({loop: 1})
        .add({
            targets: '.exp-modal',
            translateY: ["100%", 0],
            opacity:[0,1],
            translateZ: 0,
            duration: 1000,
            delay: function(el, i) {
                return 50 * i;
            }
        })
    };
    //关闭弹窗
    closeModal = () =>{
        this.setState({
            visible: false
        });
        this.state.timer=setInterval(()=>{
            if(this.state.isEnName){
                this.setState({
                    isEnName:false
                })
            }else{
                this.setState({
                    isEnName:true
                })
            }
        }, 3000)
    };
    //显示联系方式
    showConcat = () => {
        anime.timeline({loop: 1})
        .add({
            targets: '.contact-type',
            translateX: ["8em", 0],
            opacity:[0,1],
            translateZ: 0,
            duration: 2000
        })
    }
    //跳软件
    goFace = () => {
        const { faceUrl } = this.state;
        console.log(faceUrl)
        window.open(faceUrl)
    }
    //跳微博
    goWeibo = () => {
        const { microblog } = this.state;
        window.open(microblog)
    }
    /*列表数据请求*/
    contactRequest = () => {
        let _this = this;
        var params = {key:"contact"};
        this.setState({
            isLoading: true
        });
        Axios.get({
            block: '/api/option',
            url: '/queryOption',
            params: params,
        }).then((data) => {
            console.log(data)
            if(data.code === 0){
                let items = data.data;
                console.log(JSON.parse(items))
                let item = JSON.parse(items);
                let officeAddress = item.officeAddress;
                let faceUrl = item.facebook;
                console.log(item)
                let microblog = item.microblog;
                let video = item.video.showurl;
                console.log(video)
                this.setState({
                    officeAddress,
                    faceUrl,
                    microblog,
                    video
                })
                this.showConcat();
            }else{
                message.error(data.msg)
            }
           /* this.setState({
                isLoading: false
            })*/
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
        }).catch((error) => {
            console.log(error);
        })
    };
    render() {
        const { visible, officeAddress,faceUrl, microblog, video,modalInfo,isEn,isLoading,isEnName  } = this.state;
        console.log(officeAddress)
        return (
            <div>
                {
                    isLoading ? <Loader cTitle="联系" eTitle="CONTACT"/>
                        : <div className="content-box" style={{overflow:'hidden'}}>
                            <Player
                                src={Utils.getUrl(video)}
                                muted={true}
                                autoPlay={true}
                                preload="auto"
                                loop
                                fluid={true}
                                // controls
                                className="video-css"
                                width="100"
                                height="100"
                            >
                                <LoadingSpinner/>
                                <BigPlayButton position="center" style={{"margin-top":"1.25em"}}/>
                             {/*   <ControlBar autoHide={true} disableDefaultControls>
                                    <VolumeMenuButton/>
                                </ControlBar>*/}
                                <ControlBar autoHide={true} disableDefaultControls={true}>
                                </ControlBar>
                            </Player>
                            <header className="header-title">
                                <h1 className="white">
                                    <a href="/contact">contact</a>
                                </h1>
                            </header>
                            <div className="contain">
                                <div className="title">
                                    <ul className="city-name">
                                        {
                                            officeAddress ?
                                                officeAddress.map((item, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {
                                                                isEnName?
                                                                    <div className = "animation-ch" onClick={(e) => this.showModal(e, item.name)} ref='nameCn'> {item.name}&nbsp;&nbsp; / </div> :
                                                                    <div className="animation-en" onClick={(e) => this.showModal(e, item.nameEn)} ref='nameEn'>{item.nameEn}&nbsp;&nbsp; /</div>
                                                            }
                                                        </li>

                                                    )
                                                }) : ''
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="contact-type">
                                <ul className="contact-list">
                                    <li>
                                        <a href="javaScript:void(0);" onClick={this.goFace}><img src={facebook}/></a>
                                    </li>
                                    <li><a href="javaScript:void(0);" onClick={this.goWeibo}><img src={weibo}/></a></li>
                                </ul>
                            </div>
                            <Footer/>
                             {/*<Nav/>*/}
                            {/*弹窗*/}
                            {
                                visible ?
                                    <div className="city-exp">
                                        <div className="exp-modal">
                                            <a className="close" onClick={this.closeModal}>
                                                <img src={close}/>
                                            </a>
                                            <div className="exp-form">
                                                <a className="exp-title transform0">{isEn ? modalInfo.nameEn : modalInfo.name}</a>
                                                <div className="form">
                                                    <div className="form-item transform1">
                                                        <label>{!isEn ? <span>公 司 地 址 </span> :
                                                            <span>Physhical  Adress</span>}</label>
                                                        <p>{isEn ? modalInfo.addressEn : modalInfo.address}</p>
                                                    </div>

                                                    <div className="form-item transform2">
                                                        <label>{!isEn ? <span>联 系 方 式 </span> :
                                                            <span>Contact  Information</span>}</label>
                                                        <p>Tel / Fax ： {modalInfo.tel}</p>
                                                    </div>
                                                    <div className="form-item transform3">
                                                        <label>{!isEn ? <span>电 子 邮 箱</span> :
                                                            <span>E - mail</span>}</label>
                                                        <p>{modalInfo.email}</p>
                                                    </div>
                                                    <div className="form-item transform4">
                                                        <label>{!isEn ? <span>邮 政 编 码</span> :
                                                            <span> Postal  Code</span>}</label>
                                                        <p>Pos / Code ： {modalInfo.postcode}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    ''
                            }
                        </div>
                }
            </div>

        )
    }
}
